"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinancialTab = void 0;
const api_1 = require("client/api");
const confirmation_modal_1 = require("client/components/confirmation-modal");
const icons_1 = require("client/components/icons");
const button_1 = require("client/components/material/button");
const checkbox_1 = require("client/components/material/checkbox/checkbox");
const date_picker_1 = require("client/components/material/date-picker/date-picker");
const select_1 = require("client/components/material/select");
const text_field_1 = require("client/components/material/text-field");
const ui_1 = require("client/components/ui");
const store_1 = require("client/modules/sites/modules/sites-detail/store");
const store_2 = require("client/modules/users/store");
const Add_1 = require("material-ui-icons/Add");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const moment = require("moment-timezone");
const React = require("react");
const react_1 = require("react");
const site_cardconnect_1 = require("shared/site-cardconnect");
const permissions_1 = require("shared/permissions");
const state_normalize_1 = require("shared/util/state-normalize");
const gateway_api_info_modal_1 = require("./components/gateway-api-info-modal");
require("./financial.less");
/** CardPointe builds a fresh login session from this page; do not hardcode a one-time OAuth URL. */
const CARDPOINTE_LOGIN_URL = "https://www.cardpointe.com/account/login";
const US_STATE_OPTIONS = state_normalize_1.US_STATE_CODE_LIST.map((code, index) => ({
    id: index,
    label: code,
    value: code
}));
const pad2 = (value) => `${value}`.padStart(2, "0");
let FinancialTab = class FinancialTab extends react_1.Component {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.saving = false;
        this.creating = false;
        this.requestingSignature = false;
        this.refreshingStatus = false;
        this.error = "";
        this.status = ui_1.FormStatus.Clean;
        this.confirmCreate = false;
        this.showGatewayApiInfo = false;
        /** Unsaved edits; gates Save draft so the same draft cannot be resaved. */
        this.dirty = false;
        /** A draft row exists for this site, so boarding has something to submit. */
        this.savedDraft = false;
        this.view = null;
        this.form = site_cardconnect_1.emptySiteCardConnectInput(0);
        /** UI-only halves of form.ownerName, which is still sent as one string. */
        this.ownerFirstName = "";
        this.ownerLastName = "";
        /**
         * Copied deposit ciphertext is not a keepable withdrawal account. After
         * unchecking "same as deposit", hide the "leave blank to keep" labels.
         */
        this.ignoreStoredWithdrawalSecrets = false;
        this.load = async () => {
            const siteId = Number(this.props.params[0]);
            if (!siteId)
                return;
            this.loading = true;
            this.error = "";
            this.form = site_cardconnect_1.emptySiteCardConnectInput(siteId);
            this.ownerFirstName = "";
            this.ownerLastName = "";
            this.ignoreStoredWithdrawalSecrets = false;
            this.savedDraft = false;
            this.dirty = false;
            this.showGatewayApiInfo = false;
            const result = await api_1.PaymentEndpoint.readSiteCardConnect.apiCall(null, {
                siteId
            });
            this.loading = false;
            if (api_1.isError(result)) {
                this.error =
                    result.errProp || result.code || "Unable to load financial data.";
                this.status = ui_1.FormStatus.Error;
                return;
            }
            if (result.financial) {
                this.savedDraft = true;
                this.applyView(result.financial);
                // Still boarding: keep polling CoPilot. Active + Gateway MID is finished,
                // so opening the tab does not call CoPilot again. Refresh status stays manual.
                const boardingFinished = result.financial.boardingStatus === "active" &&
                    !!(result.financial.gatewayMid || "").trim();
                if (result.financial.copilotMerchantId && !boardingFinished) {
                    await this.onRefreshStatus(true);
                }
            }
            else {
                this.view = null;
            }
            this.status = ui_1.FormStatus.Clean;
        };
        this.applyView = (financial) => {
            this.ignoreStoredWithdrawalSecrets = false;
            this.dirty = false;
            this.view = financial;
            const ownerName = site_cardconnect_1.splitOwnerName(financial.ownerName);
            this.ownerFirstName = ownerName.firstName;
            this.ownerLastName = ownerName.lastName;
            this.form = {
                siteId: financial.siteId,
                ownerName: financial.ownerName,
                ownerTitle: financial.ownerTitle,
                ownerEmail: financial.ownerEmail,
                ownerPhone: site_cardconnect_1.normalizeOwnerPhone(financial.ownerPhone),
                ownerDob: financial.ownerDob || "",
                ownerAddress1: financial.ownerAddress1,
                ownerAddress2: financial.ownerAddress2,
                ownerCity: financial.ownerCity,
                ownerState: financial.ownerState,
                ownerZip: financial.ownerZip,
                ownerCountryCd: financial.ownerCountryCd || "US",
                ownerDriversLicenseNumber: "",
                ownerDriversLicenseStateCd: financial.ownerDriversLicenseStateCd,
                ownerOwnershipPct: financial.ownerOwnershipPct == null ? 100 : financial.ownerOwnershipPct,
                additionalOwners: site_cardconnect_1.sanitizeAdditionalOwners(financial.additionalOwners).map(owner => (Object.assign(Object.assign({}, owner), { ownerPhone: site_cardconnect_1.normalizeOwnerPhone(owner.ownerPhone) }))),
                depositBankName: financial.depositBankName,
                depositBankAcctTypeCd: financial.depositBankAcctTypeCd || "BIZ",
                depositBankAcctNum: "",
                depositBankRoutingNum: "",
                withdrawalSameAsDeposit: financial.withdrawalSameAsDeposit,
                withdrawalBankName: financial.withdrawalBankName,
                withdrawalBankAcctTypeCd: financial.withdrawalBankAcctTypeCd || "BIZ",
                withdrawalBankAcctNum: "",
                withdrawalBankRoutingNum: ""
            };
        };
        this.markDirty = () => {
            this.dirty = true;
            this.status = ui_1.FormStatus.Dirty;
        };
        /** First letter of each word upper; rest lower. Keeps trailing spaces while typing. */
        this.toNameCase = (value) => value.replace(/\S+/g, word => word.charAt(0).toUpperCase().concat(word.slice(1).toLowerCase()));
        this.setField = (field) => (_event, value) => {
            const titleCaseFields = [
                "ownerCity",
                "depositBankName",
                "withdrawalBankName"
            ];
            this.form[field] =
                titleCaseFields.indexOf(field) >= 0 ? this.toNameCase(value) : value;
            this.markDirty();
            this.error = "";
        };
        this.setSelectField = (field) => (value) => {
            this.form[field] = value || "";
            this.markDirty();
            this.error = "";
        };
        this.setPhoneField = (field) => (_event, value) => {
            this.form[field] = site_cardconnect_1.formatOwnerPhone(value);
            this.markDirty();
            this.error = "";
        };
        this.setZipField = (field) => (_event, value) => {
            this.form[field] = site_cardconnect_1.formatOwnerZip(value);
            this.markDirty();
            this.error = "";
        };
        /** CoPilot rejects bank numbers with symbols, so they never get typed. */
        this.setBankNumberField = (field, maxLength) => (_event, value) => {
            this.form[field] = site_cardconnect_1.formatBankNumber(value, maxLength);
            this.markDirty();
            this.error = "";
        };
        /** Picker hands back a moment/Date; the form keeps ISO like patient birthdate. */
        this.setOwnerDob = (value) => {
            const picked = value ? new Date(value) : null;
            this.form.ownerDob =
                picked && !isNaN(picked.getTime())
                    ? `${picked.getFullYear()}-${pad2(picked.getMonth() + 1)}-${pad2(picked.getDate())}`
                    : "";
            this.markDirty();
            this.error = "";
        };
        this.setOwnerNamePart = (part) => (_event, value) => {
            const formatted = this.toNameCase(value);
            if (part === "first") {
                this.ownerFirstName = formatted;
            }
            else {
                this.ownerLastName = formatted;
            }
            this.form.ownerName = site_cardconnect_1.joinOwnerName(this.ownerFirstName, this.ownerLastName);
            this.markDirty();
            this.error = "";
        };
        this.setAdditionalOwnerSelect = (index, field) => (value) => {
            const owners = [...(this.form.additionalOwners || [])];
            if (!owners[index])
                return;
            owners[index] = Object.assign(Object.assign({}, owners[index]), { [field]: value || "" });
            this.form.additionalOwners = owners;
            this.markDirty();
            this.error = "";
        };
        this.toggleWithdrawalSame = () => {
            const next = !this.form.withdrawalSameAsDeposit;
            this.form.withdrawalSameAsDeposit = next;
            if (!next) {
                this.form.withdrawalBankAcctNum = "";
                this.form.withdrawalBankRoutingNum = "";
                this.ignoreStoredWithdrawalSecrets = true;
            }
            this.markDirty();
        };
        this.addAdditionalOwner = () => {
            if (this.isLocked)
                return;
            const owners = this.form.additionalOwners || [];
            if (owners.length >= site_cardconnect_1.MAX_ADDITIONAL_OWNERS)
                return;
            this.form.additionalOwners = [...owners, site_cardconnect_1.emptyAdditionalOwner()];
            this.markDirty();
            this.error = "";
        };
        this.removeAdditionalOwner = (index) => {
            if (this.isLocked)
                return;
            this.form.additionalOwners = (this.form.additionalOwners || []).filter((_owner, i) => i !== index);
            if (!this.form.additionalOwners.length) {
                this.form.ownerOwnershipPct = 100;
            }
            this.markDirty();
            this.error = "";
        };
        this.setAdditionalOwnerField = (index, field) => (_event, value) => {
            const owners = [...(this.form.additionalOwners || [])];
            if (!owners[index])
                return;
            owners[index] = Object.assign(Object.assign({}, owners[index]), { [field]: this.normalizeOwnerValue(field, value) });
            this.form.additionalOwners = owners;
            this.markDirty();
            this.error = "";
        };
        this.normalizeOwnerValue = (field, value) => {
            if (field === "ownershipPct")
                return Number(value) || 0;
            if (field === "ownerPhone")
                return site_cardconnect_1.formatOwnerPhone(value);
            if (field === "ownerZip")
                return site_cardconnect_1.formatOwnerZip(value);
            if (field === "ownerFirstName" ||
                field === "ownerLastName" ||
                field === "ownerCity") {
                return this.toNameCase(value);
            }
            return value;
        };
        this.setOwnershipPct = (_event, value) => {
            this.form.ownerOwnershipPct = Number(value) || 0;
            this.markDirty();
            this.error = "";
        };
        this.onSaveDraft = async () => {
            this.saving = true;
            this.error = "";
            this.status = ui_1.FormStatus.Saving;
            const result = await api_1.PaymentEndpoint.saveSiteCardConnect.apiCall(null, {
                financial: this.form
            });
            this.saving = false;
            if (api_1.isError(result)) {
                this.error = result.errProp || result.code || "Save failed.";
                this.status = ui_1.FormStatus.Error;
                return;
            }
            this.savedDraft = true;
            this.applyView(result.financial);
            this.status = ui_1.FormStatus.Saved;
        };
        this.onRequestCreateMerchant = () => {
            const problems = this.createErrors;
            if (problems.length) {
                this.error = [
                    problems.length === 1
                        ? "Fix this before creating the merchant:"
                        : `Fix these ${problems.length} items before creating the merchant:`,
                    ...problems.map(problem => `• ${problem}`)
                ].join("\n");
                this.status = ui_1.FormStatus.Error;
                return;
            }
            this.confirmCreate = true;
        };
        this.onCreateMerchant = async () => {
            this.confirmCreate = false;
            this.creating = true;
            this.error = "";
            this.status = ui_1.FormStatus.Saving;
            const result = await api_1.PaymentEndpoint.createSiteCardConnectMerchant.apiCall(null, { siteId: this.form.siteId, financial: this.form });
            this.creating = false;
            const userId = store_2.usersStore.user && store_2.usersStore.user.value && store_2.usersStore.user.value.id;
            const writeLog = async (action) => {
                if (!userId)
                    return;
                const logData = {
                    user: userId,
                    action,
                    category: store_2.LogCategory.pharmacy,
                    categoryReferenceKey: this.form.siteId,
                    site: this.form.siteId
                };
                await store_2.usersStore.createLog(logData);
            };
            if (api_1.isError(result)) {
                this.error = result.errProp || result.code || "Create merchant failed.";
                this.status = ui_1.FormStatus.Error;
                if (result.financial) {
                    this.applyView(result.financial);
                }
                await writeLog(`CardConnect merchant create failed for site ${this.form.siteId}.`);
                return;
            }
            this.applyView(result.financial);
            this.status = ui_1.FormStatus.Saved;
            const merchantId = result.merchantId ||
                (result.financial && result.financial.copilotMerchantId);
            await writeLog(merchantId
                ? `CardConnect merchant ${merchantId} created for site ${this.form.siteId}.`
                : `CardConnect merchant created for site ${this.form.siteId}.`);
        };
        this.onRequestSignature = async () => {
            this.requestingSignature = true;
            this.error = "";
            const result = await api_1.PaymentEndpoint.requestSiteCardConnectSignature.apiCall(null, { siteId: this.form.siteId });
            this.requestingSignature = false;
            if (api_1.isError(result)) {
                this.error =
                    result.errProp || result.code || "Unable to create the signature link.";
                if (result.financial) {
                    this.applyView(result.financial);
                }
                this.status = ui_1.FormStatus.Error;
                return;
            }
            this.applyView(result.financial);
            this.status = ui_1.FormStatus.Saved;
        };
        this.onRefreshStatus = async (silent = false) => {
            if (!this.form.siteId || !this.view || !this.view.copilotMerchantId)
                return;
            this.refreshingStatus = true;
            if (!silent)
                this.error = "";
            const result = await api_1.PaymentEndpoint.refreshSiteCardConnectStatus.apiCall(null, { siteId: this.form.siteId });
            this.refreshingStatus = false;
            if (api_1.isError(result)) {
                if (!silent) {
                    this.error =
                        result.errProp || result.code || "Unable to refresh boarding status.";
                    this.status = ui_1.FormStatus.Error;
                }
                return;
            }
            this.applyView(result.financial);
            if (!silent)
                this.status = ui_1.FormStatus.Saved;
        };
        this.onOpenCardPointe = () => {
            window.open(CARDPOINTE_LOGIN_URL, "_blank", "noopener,noreferrer");
        };
        this.onGatewayApiInfoSaved = (hasCredentials) => {
            this.showGatewayApiInfo = false;
            if (this.view) {
                this.view = Object.assign(Object.assign({}, this.view), { hasGatewayApiCredentials: hasCredentials });
            }
            this.status = ui_1.FormStatus.Saved;
        };
        this.formatSiteDateTime = (value) => {
            if (!value)
                return "";
            const site = store_1.sitesDetailStore.site.value;
            const zone = (site && site.timezone) || moment.tz.guess();
            const time = moment.tz(value, zone);
            return time.isValid() ? time.format("MM/DD/YYYY hh:mm A") : "";
        };
    }
    componentDidMount() {
        this.load();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.params[0] !== this.props.params[0]) {
            this.load();
        }
    }
    keepWithdrawalSecrets() {
        return !!(this.view &&
            this.view.hasWithdrawalBankSecrets &&
            !this.ignoreStoredWithdrawalSecrets &&
            !this.form.withdrawalSameAsDeposit);
    }
    /** Gateway credentials are a Dev-only task, and only once the MID is boarded. */
    get canShowGatewayApiInfo() {
        const user = store_2.usersStore.user && store_2.usersStore.user.value;
        return !!(user &&
            user.groupId === permissions_1.GROUPS.DEV &&
            this.view &&
            site_cardconnect_1.isGatewayApiInfoAvailable(this.view.gatewayMid, this.view.gatewayBoardingStatusCd));
    }
    /** CardPointe link for any role, using the same MID + BOARDED rule as the credentials button. */
    get canShowCardPointeLink() {
        return !!(this.view &&
            site_cardconnect_1.isGatewayApiInfoAvailable(this.view.gatewayMid, this.view.gatewayBoardingStatusCd));
    }
    get isLocked() {
        return !!(this.view && this.view.copilotMerchantId);
    }
    /**
     * Draft: show mask + "leave blank to keep" in the label.
     * Locked (merchant created): plain label; mask goes in the field value.
     */
    secretFieldLabel(base, hasSecret, masked) {
        if (this.isLocked || !hasSecret || !masked)
            return `${base} *`;
        return `${base} (${masked} — leave blank to keep) *`;
    }
    secretFieldValue(hasSecret, masked, draftValue) {
        if (this.isLocked && hasSecret)
            return masked || "";
        return draftValue || "";
    }
    /**
     * Everything CoPilot requires, so an incomplete form never reaches the
     * gateway. Owners removed from the form drop out of the list with their row.
     */
    get createErrors() {
        return site_cardconnect_1.validateSiteCardConnectForCreate(this.form, {
            hasDepositBankSecrets: !!(this.view && this.view.hasDepositBankSecrets),
            hasWithdrawalBankSecrets: this.keepWithdrawalSecrets(),
            hasDriversLicense: !!(this.view && this.view.hasDriversLicense),
            site: store_1.sitesDetailStore.site.value
        });
    }
    get ownershipTotal() {
        const extra = (this.form.additionalOwners || []).reduce((sum, owner) => sum + (Number(owner.ownershipPct) || 0), 0);
        return (Number(this.form.ownerOwnershipPct) || 0) + extra;
    }
    renderCard(title, body, subtitle, action) {
        return (React.createElement("section", { className: "site-cc-financial__card" },
            React.createElement("header", { className: "site-cc-financial__card-head" },
                React.createElement("div", { className: "site-cc-financial__card-heading" },
                    React.createElement("h3", null, title),
                    subtitle && React.createElement("p", { className: "site-cc-financial__hint" }, subtitle)),
                action),
            body));
    }
    renderReadonly(label, value) {
        return (React.createElement("div", { key: label },
            React.createElement("label", null, label),
            React.createElement("div", { className: "site-cc-financial__readonly-value" }, value || "—")));
    }
    renderPill(value, approved, pending, fallback) {
        const upper = (value || "").toUpperCase();
        const tone = approved.indexOf(upper) >= 0
            ? "ok"
            : pending.indexOf(upper) >= 0
                ? "pending"
                : "neutral";
        return (React.createElement("span", { className: `site-cc-financial__pill site-cc-financial__pill--${tone}` }, value || fallback));
    }
    /**
     * Staff routinely miss the signature step after creating the merchant, so
     * spell it out until CoPilot reports the application as signed.
     */
    renderSignatureNotice() {
        const signed = (this.view.signatureStatusCd || "").toUpperCase() === "SIGNED" ||
            !!this.view.signedAt;
        if (signed)
            return null;
        return (React.createElement("div", { className: "site-cc-financial__notice" },
            React.createElement("strong", null, "Signature required."),
            " ",
            this.view.signatureUrl
                ? "This pharmacy cannot accept card payments until the merchant application is signed. Click Open digital application, complete and sign the form, then click Refresh status."
                : "Click Update & send for signature, then have the owner complete and sign the application before this pharmacy can accept card payments."));
    }
    renderAdditionalOwner(owner, index, locked, busy) {
        return (React.createElement("div", { className: "site-cc-financial__owner", key: `additional-owner-${index}` },
            React.createElement("div", { className: "site-cc-financial__owner-head" },
                React.createElement("span", { className: "site-cc-financial__owner-title" },
                    React.createElement("span", { className: "site-cc-financial__badge" }, index + 2),
                    "Additional Owner"),
                !locked && (React.createElement("button", { "aria-label": `Remove additional owner ${index + 1}`, className: "site-cc-financial__remove-owner", disabled: busy, title: "Remove additional owner", type: "button", onClick: () => this.removeAdditionalOwner(index) },
                    React.createElement(icons_1.DeleteIcon, null)))),
            React.createElement("div", { className: "site-cc-financial__grid" },
                React.createElement("div", { className: "site-cc-financial__col-4" },
                    React.createElement(text_field_1.MaterialTextField, { label: "First name *", value: owner.ownerFirstName, disabled: locked || busy, onChange: this.setAdditionalOwnerField(index, "ownerFirstName") })),
                React.createElement("div", { className: "site-cc-financial__col-4" },
                    React.createElement(text_field_1.MaterialTextField, { label: "Last name *", value: owner.ownerLastName, disabled: locked || busy, onChange: this.setAdditionalOwnerField(index, "ownerLastName") })),
                React.createElement("div", { className: "site-cc-financial__col-4" },
                    React.createElement(select_1.MaterialSelect
                    // Remounts when the row shifts after a removal, so the dropdown
                    // never shows a deleted owner's value.
                    , { 
                        // Remounts when the row shifts after a removal, so the dropdown
                        // never shows a deleted owner's value.
                        key: `owner-title-${index}-${owner.ownerTitle}`, label: "Title *", placeholder: "Select title", options: site_cardconnect_1.OWNER_TITLE_OPTIONS, value: owner.ownerTitle, disabled: locked || busy, onSelect: this.setAdditionalOwnerSelect(index, "ownerTitle"), backgroundColor: false, showDisabledSites: false })),
                React.createElement("div", { className: "site-cc-financial__col-6" },
                    React.createElement(text_field_1.MaterialTextField, { label: "Email *", value: owner.ownerEmail, disabled: locked || busy, error: !!owner.ownerEmail && !site_cardconnect_1.isValidOwnerEmail(owner.ownerEmail), helperText: owner.ownerEmail && !site_cardconnect_1.isValidOwnerEmail(owner.ownerEmail)
                            ? site_cardconnect_1.OWNER_EMAIL_HINT
                            : undefined, onChange: this.setAdditionalOwnerField(index, "ownerEmail") })),
                React.createElement("div", { className: "site-cc-financial__col-6" },
                    React.createElement(text_field_1.MaterialTextField, { label: "Phone *", placeholder: "123-456-7890", value: owner.ownerPhone, disabled: locked || busy, inputProps: { maxLength: 12 }, error: !!owner.ownerPhone && !site_cardconnect_1.isValidOwnerPhone(owner.ownerPhone), helperText: owner.ownerPhone && !site_cardconnect_1.isValidOwnerPhone(owner.ownerPhone)
                            ? site_cardconnect_1.OWNER_PHONE_HINT
                            : undefined, onChange: this.setAdditionalOwnerField(index, "ownerPhone") })),
                React.createElement("div", { className: "site-cc-financial__col-6" },
                    React.createElement(text_field_1.MaterialTextField, { label: "Address 1 *", value: owner.ownerAddress1, disabled: locked || busy, onChange: this.setAdditionalOwnerField(index, "ownerAddress1") })),
                React.createElement("div", { className: "site-cc-financial__col-6" },
                    React.createElement(text_field_1.MaterialTextField, { label: "Address 2", value: owner.ownerAddress2, disabled: locked || busy, onChange: this.setAdditionalOwnerField(index, "ownerAddress2") })),
                React.createElement("div", { className: "site-cc-financial__col-6" },
                    React.createElement(text_field_1.MaterialTextField, { label: "City *", value: owner.ownerCity, disabled: locked || busy, onChange: this.setAdditionalOwnerField(index, "ownerCity") })),
                React.createElement("div", { className: "site-cc-financial__col-3" },
                    React.createElement(select_1.MaterialSelect, { key: `owner-state-${index}-${owner.ownerState}`, label: "State *", placeholder: "State", options: US_STATE_OPTIONS, value: owner.ownerState, disabled: locked || busy, searchable: true, onSelect: this.setAdditionalOwnerSelect(index, "ownerState"), backgroundColor: false, showDisabledSites: false })),
                React.createElement("div", { className: "site-cc-financial__col-3" },
                    React.createElement(text_field_1.MaterialTextField, { label: "ZIP *", placeholder: "12345", value: owner.ownerZip, disabled: locked || busy, inputProps: { maxLength: 5 }, error: !!owner.ownerZip && !site_cardconnect_1.isValidOwnerZip(owner.ownerZip), helperText: owner.ownerZip && !site_cardconnect_1.isValidOwnerZip(owner.ownerZip)
                            ? site_cardconnect_1.OWNER_ZIP_HINT
                            : undefined, onChange: this.setAdditionalOwnerField(index, "ownerZip") })),
                React.createElement("div", { className: "site-cc-financial__col-3" },
                    React.createElement(text_field_1.MaterialTextField, { label: "% Ownership *", value: String(owner.ownershipPct || ""), disabled: locked || busy, onChange: this.setAdditionalOwnerField(index, "ownershipPct") })))));
    }
    renderSiteSummary() {
        const site = store_1.sitesDetailStore.site.value;
        const fromView = this.view;
        const legal = (fromView && fromView.siteLegalName) || (site && site.name) || "—";
        const dba = (fromView && fromView.siteDba) || (site && site.dba) || "—";
        const addr = (fromView && fromView.siteAddressLine) ||
            (site
                ? [site.address, site.city, site.state, site.zip]
                    .filter(Boolean)
                    .join(", ")
                : "—");
        const taxId = (fromView && fromView.siteTaxId) || (site && site.taxId) || "—";
        // Show the same values the merchant create call sends to CoPilot.
        const phone = site_cardconnect_1.toCopilotBusinessPhone((fromView && fromView.sitePhone) || (site && site.phone)) || "—";
        const website = site_cardconnect_1.toCopilotWebsite((fromView && fromView.siteWebsite) || (site && site.website)) || "—";
        // These names become CoPilot's taxFilingName, which rejects anything
        // outside letters, numbers, spaces, "&" and "-". Flag it on the card that
        // shows the value, since the fix happens on the Details tab.
        const nameProblems = [
            { label: "Legal name", chars: site_cardconnect_1.findDisallowedBusinessNameChars(legal) },
            { label: "DBA", chars: site_cardconnect_1.findDisallowedBusinessNameChars(dba) }
        ]
            .filter(entry => entry.chars.length > 0)
            .map(entry => `${entry.label} cannot contain ${entry.chars
            .map(char => `"${char}"`)
            .join(" ")}`);
        return this.renderCard("Pharmacy details", React.createElement("div", { className: "site-cc-financial__readonly-grid" },
            this.renderReadonly("Legal name", legal),
            this.renderReadonly("DBA", dba),
            this.renderReadonly("Address", addr),
            this.renderReadonly("Tax ID", taxId),
            this.renderReadonly("Business phone", phone),
            this.renderReadonly("Website", website)), React.createElement(React.Fragment, null,
            this.isLocked
                ? "Before signing, correct legal name or DBA on the Details tab, then click Update & send for signature to sync CardConnect."
                : "These details cannot be edited here. Please update them on the Details tab before creation.",
            nameProblems.length > 0 && (React.createElement("span", { className: "site-cc-financial__hint--error" }, `\nCardConnect will reject this: ${nameProblems.join(", ")}. ${site_cardconnect_1.BUSINESS_NAME_HINT}. Fix it on the Details tab.`))));
    }
    renderMerchantInfo() {
        if (!this.view || !this.view.copilotMerchantId)
            return null;
        return (React.createElement("div", { className: "site-cc-financial__merchant" },
            this.renderSignatureNotice(),
            React.createElement("div", { className: "site-cc-financial__status-bar" },
                React.createElement("div", { className: "site-cc-financial__status-item" },
                    React.createElement("label", null, "CoPilot merchant ID"),
                    this.view.copilotMerchantId),
                React.createElement("div", { className: "site-cc-financial__status-item" },
                    React.createElement("label", null, "Boarding status"),
                    this.renderPill(this.view.boardingStatus, ["BOARDED", "LIVE", "APPROVED", "COMPLETE"], ["PENDING", "PROCESSING", "SUBMITTED"], "Pending")),
                React.createElement("div", { className: "site-cc-financial__status-item" },
                    React.createElement("label", null, "Gateway MID"),
                    this.view.gatewayMid || "Pending (confirm after boarding)"),
                React.createElement("div", { className: "site-cc-financial__status-actions" },
                    this.view.signatureUrl ? (React.createElement("a", { className: "site-cc-financial__signature-link", href: this.view.signatureUrl, target: "_blank", rel: "noopener noreferrer" }, "Open digital application")) : (this.view.signatureStatusCd || "").toUpperCase() ===
                        "SIGNED" || this.view.signedAt ? null : (React.createElement(button_1.MaterialButton, { disabled: this.requestingSignature || this.refreshingStatus, onClick: this.onRequestSignature }, this.requestingSignature
                        ? "Generating…"
                        : "Update & send for signature")),
                    this.canShowCardPointeLink && (React.createElement(button_1.MaterialButton, { onClick: this.onOpenCardPointe }, "CardPointe")),
                    this.canShowGatewayApiInfo && this.view && (React.createElement(button_1.MaterialButton, { disabled: this.refreshingStatus, onClick: () => {
                            this.showGatewayApiInfo = true;
                        } }, this.view.hasGatewayApiCredentials
                        ? "Update API credentials"
                        : "Add API credentials")),
                    React.createElement(button_1.MaterialButton, { disabled: this.requestingSignature || this.refreshingStatus, onClick: () => this.onRefreshStatus(false) }, this.refreshingStatus ? "Refreshing…" : "Refresh status"))),
            this.renderCard("Boarding details", React.createElement("div", { className: "site-cc-financial__readonly-grid" },
                React.createElement("div", null,
                    React.createElement("label", null, "Signature"),
                    React.createElement("div", { className: "site-cc-financial__readonly-value" }, this.renderPill(this.view.signatureStatusCd, ["SIGNED"], ["SENT", "PENDING", "VIEWED"], "Not sent"))),
                React.createElement("div", null,
                    React.createElement("label", null, "Gateway boarding"),
                    React.createElement("div", { className: "site-cc-financial__readonly-value" }, this.renderPill(this.view.gatewayBoardingStatusCd, ["BOARDED", "LIVE"], ["NOT_BOARDED", "PENDING", "IN_PROGRESS"], "Pending"))),
                this.renderReadonly("Signed", this.formatSiteDateTime(this.view.signedAt)),
                this.renderReadonly("Submitted", this.formatSiteDateTime(this.view.submittedAt)),
                this.renderReadonly("Last status check", this.formatSiteDateTime(this.view.lastStatusSyncAt))))));
    }
    render() {
        const siteId = Number(this.props.params[0]);
        if (!siteId) {
            return (React.createElement("div", { className: "sites__form site-cc-financial" }, "Save the pharmacy first, then open Financial to enroll CardConnect."));
        }
        const f = this.form;
        const locked = this.isLocked;
        const busy = this.loading ||
            this.saving ||
            this.creating ||
            this.requestingSignature ||
            this.refreshingStatus;
        const blockers = locked ? [] : this.createErrors;
        return (React.createElement("div", { className: "sites__form site-cc-financial" },
            React.createElement(ui_1.UiForm, { error: this.error || (this.view && this.view.lastError) || undefined, loading: busy, status: this.status, 
                // title="CardConnect Financial"
                buttons: locked
                    ? []
                    : [
                        React.createElement(button_1.MaterialButton, { key: "draft", disabled: busy || !this.dirty, title: this.dirty
                                ? "Save these changes without boarding"
                                : "No unsaved changes", onClick: this.onSaveDraft }, this.saving ? "Saving…" : "Save draft"),
                        React.createElement(button_1.MaterialButton, { key: "create", primary: true, disabled: busy || !this.savedDraft, title: !this.savedDraft
                                ? "Save a draft first"
                                : blockers.length
                                    ? blockers.join("\n")
                                    : "Submit boarding data to CardConnect", onClick: this.onRequestCreateMerchant }, this.creating ? "Creating…" : "Create merchant")
                    ] },
                this.renderMerchantInfo(),
                this.renderSiteSummary(),
                this.renderCard("Ownership", React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "site-cc-financial__owner site-cc-financial__owner--primary" },
                        React.createElement("div", { className: "site-cc-financial__owner-head" },
                            React.createElement("span", { className: "site-cc-financial__owner-title" },
                                React.createElement("span", { className: "site-cc-financial__badge" }, "1"),
                                "Business Owner")),
                        React.createElement("div", { className: "site-cc-financial__grid" },
                            React.createElement("div", { className: "site-cc-financial__col-4" },
                                React.createElement(text_field_1.MaterialTextField, { label: "Owner First Name *", value: this.ownerFirstName, disabled: locked || busy, onChange: this.setOwnerNamePart("first") })),
                            React.createElement("div", { className: "site-cc-financial__col-4" },
                                React.createElement(text_field_1.MaterialTextField, { label: "Owner Last Name *", value: this.ownerLastName, disabled: locked || busy, onChange: this.setOwnerNamePart("last") })),
                            React.createElement("div", { className: "site-cc-financial__col-4" },
                                React.createElement(select_1.MaterialSelect, { label: "Title *", placeholder: "Select title", options: site_cardconnect_1.OWNER_TITLE_OPTIONS, value: f.ownerTitle, disabled: locked || busy, onSelect: this.setSelectField("ownerTitle"), backgroundColor: false, showDisabledSites: false })),
                            React.createElement("div", { className: "site-cc-financial__col-4" },
                                React.createElement(text_field_1.MaterialTextField, { label: "Email *", value: f.ownerEmail, disabled: locked || busy, error: !!f.ownerEmail && !site_cardconnect_1.isValidOwnerEmail(f.ownerEmail), helperText: f.ownerEmail && !site_cardconnect_1.isValidOwnerEmail(f.ownerEmail)
                                        ? site_cardconnect_1.OWNER_EMAIL_HINT
                                        : undefined, onChange: this.setField("ownerEmail") })),
                            React.createElement("div", { className: "site-cc-financial__col-4" },
                                React.createElement(text_field_1.MaterialTextField, { label: "Phone *", placeholder: "123-456-7890", value: f.ownerPhone, disabled: locked || busy, inputProps: { maxLength: 12 }, error: !!f.ownerPhone && !site_cardconnect_1.isValidOwnerPhone(f.ownerPhone), helperText: f.ownerPhone && !site_cardconnect_1.isValidOwnerPhone(f.ownerPhone)
                                        ? site_cardconnect_1.OWNER_PHONE_HINT
                                        : undefined, onChange: this.setPhoneField("ownerPhone") })),
                            React.createElement("div", { className: "site-cc-financial__col-4" },
                                React.createElement(date_picker_1.MaterialDatePicker, { label: "Date of Birth *", className: "site-cc-financial__datepicker", disabled: locked || busy, disableFuture: true, missing: !!f.ownerDob && !site_cardconnect_1.isAdultOwnerDob(f.ownerDob), onChange: this.setOwnerDob, value: f.ownerDob }),
                                !!f.ownerDob && !site_cardconnect_1.isAdultOwnerDob(f.ownerDob) && (React.createElement("p", { className: "site-cc-financial__field-error" }, site_cardconnect_1.isValidOwnerDob(f.ownerDob)
                                    ? site_cardconnect_1.OWNER_AGE_HINT
                                    : site_cardconnect_1.OWNER_DOB_HINT))),
                            React.createElement("div", { className: "site-cc-financial__col-6" },
                                React.createElement(text_field_1.MaterialTextField, { label: "Address 1 *", value: f.ownerAddress1, disabled: locked || busy, onChange: this.setField("ownerAddress1") })),
                            React.createElement("div", { className: "site-cc-financial__col-6" },
                                React.createElement(text_field_1.MaterialTextField, { label: "Address 2", value: f.ownerAddress2, disabled: locked || busy, onChange: this.setField("ownerAddress2") })),
                            React.createElement("div", { className: "site-cc-financial__col-6" },
                                React.createElement(text_field_1.MaterialTextField, { label: "City *", value: f.ownerCity, disabled: locked || busy, onChange: this.setField("ownerCity") })),
                            React.createElement("div", { className: "site-cc-financial__col-3" },
                                React.createElement(select_1.MaterialSelect, { label: "State *", placeholder: "State", options: US_STATE_OPTIONS, value: f.ownerState, disabled: locked || busy, searchable: true, onSelect: this.setSelectField("ownerState"), backgroundColor: false, showDisabledSites: false })),
                            React.createElement("div", { className: "site-cc-financial__col-3" },
                                React.createElement(text_field_1.MaterialTextField, { label: "Zip Code *", placeholder: "12345", value: f.ownerZip, disabled: locked || busy, inputProps: { maxLength: 5 }, error: !!f.ownerZip && !site_cardconnect_1.isValidOwnerZip(f.ownerZip), helperText: f.ownerZip && !site_cardconnect_1.isValidOwnerZip(f.ownerZip)
                                        ? site_cardconnect_1.OWNER_ZIP_HINT
                                        : undefined, onChange: this.setZipField("ownerZip") })),
                            React.createElement("div", { className: "site-cc-financial__col-6" },
                                React.createElement(text_field_1.MaterialTextField, { label: this.secretFieldLabel("Driver's License Number", !!(this.view && this.view.hasDriversLicense), this.view && this.view.ownerDriversLicenseMasked), value: this.secretFieldValue(!!(this.view && this.view.hasDriversLicense), this.view && this.view.ownerDriversLicenseMasked, f.ownerDriversLicenseNumber || ""), disabled: locked || busy, onChange: this.setField("ownerDriversLicenseNumber") })),
                            React.createElement("div", { className: "site-cc-financial__col-3" },
                                React.createElement(select_1.MaterialSelect, { label: "DL State *", placeholder: "State", options: US_STATE_OPTIONS, value: f.ownerDriversLicenseStateCd, disabled: locked || busy, searchable: true, onSelect: this.setSelectField("ownerDriversLicenseStateCd"), backgroundColor: false, showDisabledSites: false })),
                            React.createElement("div", { className: "site-cc-financial__col-3" },
                                React.createElement(text_field_1.MaterialTextField, { label: "% Ownership *", value: String(f.ownerOwnershipPct == null ? 100 : f.ownerOwnershipPct), disabled: locked || busy, onChange: this.setOwnershipPct })))),
                    (f.additionalOwners || []).map((owner, index) => this.renderAdditionalOwner(owner, index, locked, busy)),
                    React.createElement("div", { className: "site-cc-financial__owner-footer" },
                        (f.additionalOwners || []).length > 0 && (React.createElement("div", { className: "site-cc-financial__owner-total" },
                            "Total ownership",
                            React.createElement("span", { className: `site-cc-financial__pill site-cc-financial__pill--${this.ownershipTotal === 100 ? "ok" : "error"}` },
                                this.ownershipTotal,
                                "%"))),
                        !locked &&
                            (f.additionalOwners || []).length < site_cardconnect_1.MAX_ADDITIONAL_OWNERS && (React.createElement(button_1.MaterialButton, { flat: true, className: "site-cc-financial__add-owner", disabled: busy, title: "Add Additional Owner", onClick: this.addAdditionalOwner },
                            React.createElement(Add_1.default, null),
                            "Add Owner")))), site_cardconnect_1.OWNER_KYC_DISCLAIMER),
                this.renderCard("Deposit Account", React.createElement("div", { className: "site-cc-financial__grid" },
                    React.createElement("div", { className: "site-cc-financial__col-8" },
                        React.createElement(text_field_1.MaterialTextField, { label: "Bank Name *", value: f.depositBankName, disabled: locked || busy, onChange: this.setField("depositBankName") })),
                    React.createElement("div", { className: "site-cc-financial__col-4" },
                        React.createElement(select_1.MaterialSelect, { label: "Account Type *", placeholder: "Select account type", options: site_cardconnect_1.BANK_ACCT_TYPE_OPTIONS, value: f.depositBankAcctTypeCd, disabled: locked || busy, onSelect: this.setSelectField("depositBankAcctTypeCd"), backgroundColor: false, showDisabledSites: false })),
                    React.createElement("div", { className: "site-cc-financial__col-6" },
                        React.createElement(text_field_1.MaterialTextField, { label: this.secretFieldLabel("Account Number", !!(this.view && this.view.hasDepositBankSecrets), this.view && this.view.depositBankAcctMasked), value: this.secretFieldValue(!!(this.view && this.view.hasDepositBankSecrets), this.view && this.view.depositBankAcctMasked, f.depositBankAcctNum || ""), disabled: locked || busy, inputProps: { maxLength: site_cardconnect_1.BANK_ACCT_MAX_LENGTH }, error: !!f.depositBankAcctNum &&
                                !site_cardconnect_1.isValidBankAcctNum(f.depositBankAcctNum), helperText: f.depositBankAcctNum &&
                                !site_cardconnect_1.isValidBankAcctNum(f.depositBankAcctNum)
                                ? site_cardconnect_1.BANK_ACCT_HINT
                                : undefined, onChange: this.setBankNumberField("depositBankAcctNum", site_cardconnect_1.BANK_ACCT_MAX_LENGTH) })),
                    React.createElement("div", { className: "site-cc-financial__col-6" },
                        React.createElement(text_field_1.MaterialTextField, { label: this.secretFieldLabel("Routing Number", !!(this.view && this.view.hasDepositBankSecrets), this.view && this.view.depositBankRoutingMasked), value: this.secretFieldValue(!!(this.view && this.view.hasDepositBankSecrets), this.view && this.view.depositBankRoutingMasked, f.depositBankRoutingNum || ""), disabled: locked || busy, inputProps: { maxLength: site_cardconnect_1.BANK_ROUTING_LENGTH }, error: !!f.depositBankRoutingNum &&
                                !site_cardconnect_1.isValidBankRouting(f.depositBankRoutingNum), helperText: f.depositBankRoutingNum &&
                                !site_cardconnect_1.isValidBankRouting(f.depositBankRoutingNum)
                                ? site_cardconnect_1.BANK_ROUTING_HINT
                                : undefined, onChange: this.setBankNumberField("depositBankRoutingNum", site_cardconnect_1.BANK_ROUTING_LENGTH) })),
                    React.createElement("div", { className: "site-cc-financial__col-12" },
                        React.createElement(checkbox_1.MaterialCheckbox, { label: "Withdrawal account same as deposit", checked: f.withdrawalSameAsDeposit, disabled: locked || busy, onAction: this.toggleWithdrawalSame })))),
                !f.withdrawalSameAsDeposit &&
                    this.renderCard("Withdrawal Account", React.createElement("div", { className: "site-cc-financial__grid" },
                        React.createElement("div", { className: "site-cc-financial__col-8" },
                            React.createElement(text_field_1.MaterialTextField, { label: "Bank Name *", value: f.withdrawalBankName, disabled: locked || busy, onChange: this.setField("withdrawalBankName") })),
                        React.createElement("div", { className: "site-cc-financial__col-4" },
                            React.createElement(select_1.MaterialSelect, { label: "Account Type *", placeholder: "Select account type", options: site_cardconnect_1.BANK_ACCT_TYPE_OPTIONS, value: f.withdrawalBankAcctTypeCd, disabled: locked || busy, onSelect: this.setSelectField("withdrawalBankAcctTypeCd"), backgroundColor: false, showDisabledSites: false })),
                        React.createElement("div", { className: "site-cc-financial__col-6" },
                            React.createElement(text_field_1.MaterialTextField, { label: this.secretFieldLabel("Account Number", this.keepWithdrawalSecrets(), this.view && this.view.withdrawalBankAcctMasked), value: this.secretFieldValue(this.keepWithdrawalSecrets(), this.view && this.view.withdrawalBankAcctMasked, f.withdrawalBankAcctNum || ""), disabled: locked || busy, inputProps: { maxLength: site_cardconnect_1.BANK_ACCT_MAX_LENGTH }, error: !!f.withdrawalBankAcctNum &&
                                    !site_cardconnect_1.isValidBankAcctNum(f.withdrawalBankAcctNum), helperText: f.withdrawalBankAcctNum &&
                                    !site_cardconnect_1.isValidBankAcctNum(f.withdrawalBankAcctNum)
                                    ? site_cardconnect_1.BANK_ACCT_HINT
                                    : undefined, onChange: this.setBankNumberField("withdrawalBankAcctNum", site_cardconnect_1.BANK_ACCT_MAX_LENGTH) })),
                        React.createElement("div", { className: "site-cc-financial__col-6" },
                            React.createElement(text_field_1.MaterialTextField, { label: this.secretFieldLabel("Routing Number", this.keepWithdrawalSecrets(), this.view && this.view.withdrawalBankRoutingMasked), value: this.secretFieldValue(this.keepWithdrawalSecrets(), this.view && this.view.withdrawalBankRoutingMasked, f.withdrawalBankRoutingNum || ""), disabled: locked || busy, inputProps: { maxLength: site_cardconnect_1.BANK_ROUTING_LENGTH }, error: !!f.withdrawalBankRoutingNum &&
                                    !site_cardconnect_1.isValidBankRouting(f.withdrawalBankRoutingNum), helperText: f.withdrawalBankRoutingNum &&
                                    !site_cardconnect_1.isValidBankRouting(f.withdrawalBankRoutingNum)
                                    ? site_cardconnect_1.BANK_ROUTING_HINT
                                    : undefined, onChange: this.setBankNumberField("withdrawalBankRoutingNum", site_cardconnect_1.BANK_ROUTING_LENGTH) }))))),
            this.confirmCreate && (React.createElement(confirmation_modal_1.ConfirmationModal, { title: "Create CardConnect Merchant Application", message: "This will submit the pharmacy\u2019s data to Copilot. Ensure all Details and Financial fields are complete. Once submitted, the form cannot be edited.", confirmText: "Create merchant", cancelText: "Cancel", onCancel: () => {
                    this.confirmCreate = false;
                }, onConfirm: this.onCreateMerchant })),
            this.showGatewayApiInfo && this.view && (React.createElement(gateway_api_info_modal_1.GatewayApiInfoModal, { siteId: this.form.siteId, gatewayMid: this.view.gatewayMid, onCancel: () => {
                    this.showGatewayApiInfo = false;
                }, onSaved: this.onGatewayApiInfoSaved }))));
    }
};
__decorate([
    mobx_1.observable
], FinancialTab.prototype, "loading", void 0);
__decorate([
    mobx_1.observable
], FinancialTab.prototype, "saving", void 0);
__decorate([
    mobx_1.observable
], FinancialTab.prototype, "creating", void 0);
__decorate([
    mobx_1.observable
], FinancialTab.prototype, "requestingSignature", void 0);
__decorate([
    mobx_1.observable
], FinancialTab.prototype, "refreshingStatus", void 0);
__decorate([
    mobx_1.observable
], FinancialTab.prototype, "error", void 0);
__decorate([
    mobx_1.observable
], FinancialTab.prototype, "status", void 0);
__decorate([
    mobx_1.observable
], FinancialTab.prototype, "confirmCreate", void 0);
__decorate([
    mobx_1.observable
], FinancialTab.prototype, "showGatewayApiInfo", void 0);
__decorate([
    mobx_1.observable
], FinancialTab.prototype, "dirty", void 0);
__decorate([
    mobx_1.observable
], FinancialTab.prototype, "savedDraft", void 0);
__decorate([
    mobx_1.observable
], FinancialTab.prototype, "view", void 0);
__decorate([
    mobx_1.observable
], FinancialTab.prototype, "form", void 0);
__decorate([
    mobx_1.observable
], FinancialTab.prototype, "ownerFirstName", void 0);
__decorate([
    mobx_1.observable
], FinancialTab.prototype, "ownerLastName", void 0);
__decorate([
    mobx_1.observable
], FinancialTab.prototype, "ignoreStoredWithdrawalSecrets", void 0);
__decorate([
    mobx_1.computed
], FinancialTab.prototype, "createErrors", null);
__decorate([
    mobx_1.computed
], FinancialTab.prototype, "ownershipTotal", null);
FinancialTab = __decorate([
    mobx_react_1.observer
], FinancialTab);
exports.FinancialTab = FinancialTab;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/modules/sites-detail/tabs/financial/financial.tsx
// module id = 4030
// module chunks = 0